import React from 'react';

export const BasePetSelector = ({ items, value, size = 'medium', onSelect }) => (
  <div className={`base-pet-selector size-${size}`}>
    {items.map((item) => (
      <div className={`pet ${item.value === value ? 'selected' : ''}`} key={item.value} onClick={() => onSelect(item.value)}>
        <div className="icon">{item.icon}</div>
        {item.title && <span className="title">{item.title}</span>}
      </div>
    ))}
  </div>
);
